<template>
  <div class="dialog-wrapper" v-if="dialogData">
    <div class="dialog-inner">
      <div class="dialog-header" v-if="dialogData.title">
        <h4 class="title">
          {{ dialogData.title }}
        </h4>
      </div>
      <div class="dialog-body" v-if="dialogData.message">
        <span>
          {{ dialogData.message }}
        </span>
      </div>
      <div class="dialog-input" v-if="dialogData.field">
        <div class="dialog-input-item" v-for="(item, index) in dialogData.field" :key="index">
          <label>{{ item.name }}</label>
          <input v-if="item.type === 'text'" type="text" v-model="info[item.field]" />
        </div>
      </div>
      <div class="dialog-footer" v-if="dialogData.btns && dialogData.btns.length">
        <button v-for="(item, index) in dialogData.btns" :key="index" :class="item.className" :data-link="item.link"
          :data-callback="item.callback" @click="btnClick($event, item)">
          {{ item.text }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CONFIG from "../utils/config";
import COVER from "@/utils/COVER";
import COVERAPP from "../utils/COVERAPP";

import { mapState, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {};
  },
  props: ["baseData"],
  computed: {
    ...mapState(["dialogData"]),
    info() {
      let obj = {}
      if (this.dialogData.field) {
        this.dialogData.field.map((v) => {
          obj[v.field] = ''
        })
      }
      return obj
    },
  },
  mounted() { },
  methods: {
    ...mapActions(["setDialogDataAsync"]),
    ...mapMutations(["setToastData"]),
    //分享
    share(share_data) {
      let data = share_data;
      let shareData = {
        title: data.title,
        desc: data.desc,
        imgUrl: data.imgUrl,
        link: data.link || window.location.href,
      };
      COVER.share(shareData);
    },
    btnClick(e, item) {
      const data = this.baseData;
      let _this = this;
      if (e.target.className == "login-btn") {
        if (COVERAPP.Attribute.isApp()) {
          COVERAPP.Method.OpenLogin({
            callback(ret) {
              let userinfo = JSON.parse(ret);
              if (!COVER.isEmpty(userinfo.user_id)) {
                _this.$emit("loginEvent");
              }
            },
          });
        } else {
          _this.$emit("loginEvent");
        }
      } else if (e.target.className == "wxAuthorize-btn" || e.target.className == 'lottery-wxAuthorize-btn') {
        COVERAPP.Method.wxAuthorize({
          callback(res) {
            setTimeout(() => {
              let data =
                typeof res == "string".toLowerCase()
                  ? res
                  : JSON.stringify(res);
              if (!data || JSON.parse(data).status != 1) {
                _this.setToastData({
                  text: "绑定失败",
                });
                return;
              }
              if (JSON.parse(data).status == 1) {
                _this.$emit("wxauthorizeEvent", JSON.parse(data).openid);
                if (e.target.className == "wxAuthorize-btn") {
                  _this.setToastData({
                    text: "绑定成功",
                  });
                }
              }
            }, 500);
          },
        });
      } else if (e.target.className == "link-btn") {
        let link = e.target.getAttribute("data-link") || "/";
        this.$router.push(link);
      } else if (e.target.className == "downLoad-app") {
        const img = new Image();
        img.src =
          CONFIG.ACTIVITY_URL +
          "/activity/download?aid=" +
          this.$route.query.id;
        img.onload = function () {
          console.log("下载");
        };
        COVER.$getScript(CONFIG.DOWNLOAD_ADDRESS).then(() => {
          COVER.downloadApp(this.$route.query.id, data.flag, data.news_id);
        });
      } else if (e.target.className == "share-btn") {
        item.callback();
      } else if (e.target.className == "reload-btn") {
        window.location.reload();
      } else if (e.target.className === 'info-btn') {
        if (this.dialogData.field) {
          for (let i = 0; i < this.dialogData.field.length; i++) {
            const { field, name, isMust } = this.dialogData.field[i];
            if (!this.info[field] && isMust) {
              return this.setToastData({
                text: `请填写${name}`
              })
            }
          }
        }
        if (item.callback) item.callback(this.info)
        this.setDialogDataAsync(null)
      }
      else if (item.callback) {
        item.callback()
        this.setDialogDataAsync(null)
      }
      this.setDialogDataAsync(null)
    },
  },
};
</script>

<style lang="less">
.dialog-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 2;
}

.dialog-inner {
  position: absolute;
  width: 7rem;
  background-color: #fff;
  border-radius: 0.1rem;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 0.3rem 0;
}

.dialog-header {
  padding: 0 0.3rem 0.2rem;
  line-height: 1.5;

  h4 {
    font-size: 0.6rem;
    font-weight: normal;
  }
}

.dialog-body {
  font-size: 0.4rem;
  line-height: 1.3;
  padding: 0 0.3rem 0.3rem;
  color: black;
}

.dialog-input {
  margin-bottom: 8vw;
  margin-top: 3vw;
  font-size: 4vw;
  margin-right: 4vw;

  &-item {
    display: flex;
    align-items: center;
    margin: 0 0 3vw;

    label {
      width: 4em;
    }

    input {
      flex: 1;
      width: 45vw;
      border: 1px solid;
      border-width: 0 0 1px 0;
      border-radius: 0;
      outline: 0;
    }
  }
}

.dialog-footer {
  border-top: 1px solid #aaa;
  padding: 0.3rem 0.3rem 0;
  text-align: center;

  button {
    border: none;
    outline: none;
    appearance: none;
    font-size: 0.36rem;
    color: #fff;
    display: inline-block;
    margin: 0 0.15rem;
    background-color: #000;
    padding: 0 0.3rem 0 0.4rem;
    line-height: 0.8rem;
    letter-spacing: 0.1rem;
    border-radius: 0.1rem;
  }

  .close-btn {
    background-color: #aaa;
  }
}
</style>
